import { useState } from 'react';
import { useAuth } from '~/context/AuthProvider';
import { Link } from 'react-router-dom';
import { fetchMedicalProfessional } from '~/services/medical-professionals';
import MedProfClientsList from './MedProfClientsList';

const MedicalProfessionalDashboard = () => {
    const { person } = useAuth();
    const [medProf, setMedProf] = useState<any>(null);

    // The shared list does the medProfId lookup; we hook into it here only
    // to fetch the full detail used to display the profile.
    const handleMedProfMatched = async (match: any) => {
        if (!match?.id) return;
        try {
            const detail = await fetchMedicalProfessional(match.id);
            setMedProf(detail);
        } catch (e) {
            console.error('Med pro detail fetch failed:', e);
        }
    };

    return (
        <div className='grid grid-cols-12 gap-7.5'>
            <div className='col-span-12 mb-7.5 xl:col-span-8'>
                <MedProfClientsList onMedProfMatched={handleMedProfMatched} />
            </div>

            <div className='col-span-12 mb-7.5 xl:col-span-4'>
                <div className='h-full rounded-sm border border-stroke bg-white p-4 shadow-default dark:border-strokedark dark:bg-boxdark md:p-6 xl:p-7.5'>
                    <div className='mb-4'>
                        <h2 className='text-xl font-semibold text-black dark:text-white'>
                            My Profile
                        </h2>
                    </div>
                    <div className='mb-[16px]'>
                        <label className='text-[12px]/[16px] text-[#949599]'>
                            Email
                        </label>
                        <div>
                            <Link
                                to={`mailto:${person?.email}`}
                                className='text-primary'
                            >
                                {person?.email}
                            </Link>
                        </div>
                    </div>
                    <div className='mb-[16px]'>
                        <label className='text-[12px]/[16px] text-[#949599]'>
                            Phone
                        </label>
                        {person?.phone_set?.map(
                            (phone: any, index: number) =>
                                phone?.phone && (
                                    <div key={index}>
                                        {phone?.type && (
                                            <span className='font-medium'>{`${phone?.type}: `}</span>
                                        )}
                                        {phone?.phone}
                                    </div>
                                ),
                        )}
                    </div>
                    <div className='mb-[16px]'>
                        <label className='text-[12px]/[16px] text-[#949599]'>
                            Address
                        </label>
                        <div>
                            <div>{person?.address_1}</div>
                            <div>{person?.address_2}</div>
                            <div>
                                {person?.city}, {person?.state}{' '}
                                {person?.zip_code}
                            </div>
                        </div>
                    </div>
                    <div className='mb-[16px]'>
                        <label className='text-[12px]/[16px] text-[#949599]'>
                            Medical Center
                        </label>
                        <div>
                            {medProf?.medical_center?.name ? (
                                <>
                                    <div>{medProf.medical_center.name}</div>
                                    {(medProf.medical_center.city ||
                                        medProf.medical_center.location) && (
                                        <div className='text-[12px]/[16px] text-[#949599]'>
                                            {medProf.medical_center.city}
                                            {medProf.medical_center.city &&
                                            medProf.medical_center.location
                                                ? ', '
                                                : ''}
                                            {medProf.medical_center.location}
                                        </div>
                                    )}
                                </>
                            ) : (
                                <span className='text-[#949599]'>—</span>
                            )}
                        </div>
                    </div>
                    <div className='mb-[16px]'>
                        <label className='text-[12px]/[16px] text-[#949599]'>
                            Professional Type
                        </label>
                        <div>
                            {medProf?.medical_professional_type?.name ?? (
                                <span className='text-[#949599]'>—</span>
                            )}
                        </div>
                    </div>
                    <div className='mb-[16px]'>
                        <label className='text-[12px]/[16px] text-[#949599]'>
                            Specialty
                        </label>
                        <div>
                            {medProf?.medical_reason?.name ?? (
                                <span className='text-[#949599]'>—</span>
                            )}
                        </div>
                    </div>
                    <div className='mb-[16px]'>
                        <label className='text-[12px]/[16px] text-[#949599]'>
                            Type
                        </label>
                        <div>
                            {medProf?.medical_issues?.length ? (
                                medProf.medical_issues.map(
                                    (issue: any, index: number) => (
                                        <div key={index}>{issue?.name}</div>
                                    ),
                                )
                            ) : (
                                <span className='text-[#949599]'>—</span>
                            )}
                        </div>
                    </div>
                    <div className='mt-2 flex flex-col gap-4 rounded bg-[#f4f4f5] p-3 text-black dark:text-white'>
                        <p className='text-[18px]/[22px] font-bold uppercase tracking-[1.44px]'>
                            Need to change something?
                        </p>
                        <p className='text-[16px]/[24px]'>
                            Reach out to{' '}
                            <Link
                                to='mailto:outreach@helphopelive.org'
                                className='text-primary'
                            >
                                outreach@helphopelive.org
                            </Link>{' '}
                            to update your information.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MedicalProfessionalDashboard;
